import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  error: null,
  loading: [],
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    initialize: () => initialState,
    changeError: (state, { payload }) => {
      state.error = payload;
    },
    changeLoading: (state, { payload: { id, sign } }) => {
      if (sign === 1) {
        if (!state.loading.includes(id)) {
          state.loading = [...state.loading, id];
        }
      } else if (sign === -1) {
        state.loading = state.loading.filter(loading => loading !== id);
      }
    },
  },
});

export const { initialize, changeError, changeLoading } = errorSlice.actions;

export default errorSlice.reducer;
